import { v4 as uuidv4 } from "uuid";
export class CommandRequest {
    constructor(uri, method, to, type, from, pp, resource) {
        this.id = uuidv4();
        this.uri = uri;
        this.method = method;
        if (type !== undefined)
            this.type = type;
        if (to !== undefined)
            this.to = to;
        if (from !== undefined)
            this.from = from;
        if (pp !== undefined)
            this.pp = pp;
        if (resource !== undefined)
            this.resource = resource;
    }
    setResource(resource) {
        this.resource = resource;
    }
}
